import { ClientApplication, ClientUser } from '@numeo/types-core'
import axios, { AxiosError } from 'axios'
import { ApiError, AuthUrlResponse, EmailAccount, TokenExchangeResponse } from './types'

export const GmailEmailClient = {
    async getAccounts(): Promise<{ accounts: EmailAccount[]; user: ClientUser }> {
        try {
            const response = await axios.get(`/email/accounts`)
            return response.data
        } catch (error) {
            if (error instanceof AxiosError) {
                throw new ApiError(error.response?.data?.message || 'Failed to fetch email accounts', error.response?.status)
            }
            throw error
        }
    },

    async getAuthUrl(redirectUrl: string, source: string): Promise<AuthUrlResponse> {
        try {
            const response = await axios.get(`/email/auth/gmail/auth-url?redirectUrl=${encodeURIComponent(redirectUrl)}&source=${source}`)
            return response.data
        } catch (error) {
            if (error instanceof AxiosError) {
                throw new ApiError(error.response?.data?.message || 'Failed to get Gmail auth URL', error.response?.status)
            }
            throw error
        }
    },

    async exchangeToken(code: string, source: string): Promise<TokenExchangeResponse> {
        try {
            const response = await axios.post(`/email/auth/gmail/exchange-token`, { code, source })
            return response.data
        } catch (error) {
            if (error instanceof AxiosError) {
                throw new ApiError(error.response?.data?.message || 'Failed to exchange Gmail token', error.response?.status)
            }
            throw error
        }
    },

    async disconnect(grantId: string): Promise<{ application: ClientApplication; user: ClientUser }> {
        try {
            const response = await axios.delete(`/email/auth/gmail/disconnect/${grantId}`)
            return {
                application: response.data.application,
                user: response.data.user,
            }
        } catch (error) {
            if (error instanceof AxiosError) {
                throw new ApiError(error.response?.data?.message || 'Failed to disconnect Gmail account', error.response?.status)
            }
            throw error
        }
    },

    async processOAuthCode(): Promise<TokenExchangeResponse | undefined> {
        try {
            const searchParams = new URLSearchParams(window.location.search)
            const code = searchParams.get('code')

            if (!code) {
                return
            }

            const response = await axios.post(`/email/auth/gmail/exchange-token`, { code, source: 'APP_NUMEO_AI' })
            return response.data
        } catch (error) {
            if (error instanceof AxiosError) {
                throw new ApiError(error.response?.data?.message || 'Failed to exchange Gmail token', error.response?.status)
            }
            throw error
        }
    },
}
